import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { type Picture } from '@/types/photo-uploader';
import { uploadImage } from '@/js/lib/api/upload';
import { useMQ } from '@/js/lib/helper/media-query';
import Draggable from 'vuedraggable';
import FileDroppable from '@/js/components/common/ui/file-droppable.vue';
import ImageComment from './ImageComment.vue';
import IModal from '@/js/components/molecules/IModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'photo-uploader',
  props: {
    value: { default: () => [] },
    rules: { default: '' },
    errorLabel: { default: '' },
    inputFileNameFormat: { default: '' },
    textareaNameFormat: { default: '' },
    slotSize: { default: 1 },
    isEvent: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', pictures: Picture[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: Picture[], rules: string, errorLabel: string, inputFileNameFormat: string, textareaNameFormat: string, slotSize: number, isEvent?: boolean };



let modalOpenPosition = 0;
const { isSp } = useMQ();
const hasComment = ref(Boolean(props.textareaNameFormat));
const uploading = ref(false);
const rootEl = ref();
const inputFileEl = ref<HTMLInputElement>();
const pictures = computed({
  get() {
    return (props.value as Picture[]).map((picture) => {
      return { ...picture, isShowCommentEdit: false };
    });
  },
  set(newVal) {
    emit('input', newVal);
  },
});
const filter = computed(() => [hasComment.value ? '[data-comment]' : undefined, '[data-delete]'].filter(Boolean).join(','));
const availablePictureSlots = computed(() => Math.max(props.slotSize - pictures.value.length, 0));
const imgLoaded = computed(() => (index: number) => pictures.value[index]?.loaded);
const inputFileName = computed(() => (index: number) => props.inputFileNameFormat.replace('%d', String(index)));
const textareaName = computed(() => (index: number) => props.textareaNameFormat.replace('%d', String(index)));
const uploadedFileName = computed(() => (index: number) => {
  if (pictures.value[index]) {
    return pictures.value[index].filename;
  }

  return '';
});
const openDialog = () => {
  modalOpenPosition = window.scrollY;
};
const closeDialog = () => {
  window.scrollTo(0, modalOpenPosition);
};
const uploadPictures = async (files: File[]) => {
  if (files.length === 0) {
    return;
  }
  if (files.some((file) => file.size > 104857600)) {
    rootEl.value.applyResult({
      errors: ['画像は10MB以内にしてください'],
    });
    return;
  }

  uploading.value = true;

  try {
    const fileDatas = await Promise.all(
      files.map(async (file) => {
        const fileData = await uploadImage(file);
        return fileData;
      }),
    );
    pictures.value = [
      ...pictures.value,
      ...(fileDatas as Picture[]).map((fileData) => {
        return {
          ...fileData,
          isShowCommentEdit: false,
          loaded: false,
        };
      }),
    ];
  } catch {
    rootEl.value.applyResult({
      errors: ['画像をアップロードできませんでした'],
    });
  } finally {
    uploading.value = false;
  }
};
const onPicturesChange = () => {
  const files: File[] = [...inputFileEl.value.files];
  uploadPictures(files.slice(0, availablePictureSlots.value));
  inputFileEl.value.value = '';
};
const onFileDropped = (files: File[]) => {
  uploadPictures(files.slice(0, availablePictureSlots.value));
};
const onLoadImg = (index: number) => {
  pictures.value = pictures.value.map((picture, i) => (i === index ? { ...picture, loaded: true } : picture));
};
const onRemovePictureClick = (index: number) => {
  pictures.value = pictures.value.filter((_picture, i) => i !== index);
};
const inputFileElClick = () => {
  inputFileEl.value.click();
};

return { __sfc: true,props, emit, modalOpenPosition, isSp, hasComment, uploading, rootEl, inputFileEl, pictures, filter, availablePictureSlots, imgLoaded, inputFileName, textareaName, uploadedFileName, openDialog, closeDialog, uploadPictures, onPicturesChange, onFileDropped, onLoadImg, onRemovePictureClick, inputFileElClick, Draggable, FileDroppable, ImageComment, IModal }
}

})